"use client";
import { useTheme } from "next-themes";
import { useEffect } from "react";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme("light");
    return () => setTheme("system");
  }, [setTheme]);

  return (
    <div className="max-w-screen overflow-clip">
      <div>{children}</div>
    </div>
  );
}
